import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Section, Title } from 'components/misc'
import { VideoLoop } from 'components/wide-graphics/video-loop'
import Video2 from './assets/Loop_SAKHA_2.mp4'
import { Slider } from './slider'

export const Movies = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <>
    <VideoLoop url={Video2} description="Фрагмент из трейлера к фильму “Айта” 2022" />

    <Section ref={ref}>
      <TextContainer>
        <Title data-menu-title="кино">Современное кино</Title>

        <p>
          Саха-кино начало активно развиваться с 1980-х годов и за это время
          вышло на высокий уровень. Сегодня фильмы участвуют в показах на
          международных кинофестивалях и получают высокие оценки критиков.
          Однако широкий зритель в России знает о кино саха мало. Отчасти из-за
          того, что индустрия развивается и работает преимущественно внутри
          республики.
        </p>
        <p>
          Многие режиссеры в своих фильмах берут за основу национальный
          фольклор, в частности олонхо. Именно это считается одной из главных
          причин успеха фильмов, которые продолжают выходить и радовать своих
          зрителей.
        </p>
      </TextContainer>

      <Slider />
    </Section>
  </>
))
